import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataDocument } from '../../data/DataDocument.jsx';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxDocumentLotCategorie } from '../ComboBox/ComboBoxDocumentLotCategorie';
import { ComboBoxDocumentLotType } from '../ComboBox/ComboBoxDocumentLotType';
import { ComboBoxDocumentOperationCategorie } from '../ComboBox/ComboBoxDocumentOperationCategorie';
import { ComboBoxDocumentOperationType } from '../ComboBox/ComboBoxDocumentOperationType';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/****************************************************************
 PROPS:
    rowGUID
    idLot
    idOperation
    idAgence
    idRegion
    type
    onAffichePanelDocument : bool

    onEnregistrementFiche : méthode
    onAnnuleFiche : méthode
    ****************************************************************/

var objetState = {
    rowGUID: {},
    document: {},
    estAdminNational: false,

    titrePanel: 'Créer un document',

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    onActiveBoutonEnregistrer: false,

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''
};

export class FicheDocument extends Component {
    _creationContent() {
        let nomDocument = this.state.document.nom;
        let dernierIndexPoint = (nomDocument !== undefined ? nomDocument.lastIndexOf('.') : null);
        let nomFichier = (nomDocument !== undefined ? nomDocument.substring(0, dernierIndexPoint) : null);
        let extensionFichier = (nomDocument !== undefined ? Scriba.chaine().getExtensionFichier(nomDocument) : null);

        return (
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <EUITextField
                            label="Nom"
                            maxLength={MaxLengths.document.nom}
                            onDelayedChange={(event, newValue) => this._onMiseAJourChampNomDocument("document", "nom", newValue, extensionFichier)}
                            required
                            suffix={extensionFichier}
                            value={nomFichier}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divCategorie">
                        {this.props.type === 'Operation' ?
                            <ComboBoxDocumentOperationCategorie
                                onChange={(event, option) => this._onChangedDocumentOperationCategorie(option.key)}
                                required
                                selectedKey={this.state.document.idDocumentOperationCategorie}
                            />
                            : null}

                        {this.props.type === 'Lot' ?
                            <ComboBoxDocumentLotCategorie
                                onChange={(event, option) => this._onChangedDocumentLotCategorie(option.key)}
                                required
                                selectedKey={this.state.document.idDocumentLotCategorie}
                            />
                            : null}
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divSousCategorie">
                        {this.props.type === 'Operation' ?
                            <ComboBoxDocumentOperationType
                                idDocumentOperationCategorie={this.state.document.idDocumentOperationCategorie}
                                onChange={(event, option, index, value, item) => this._onMiseAJourChamp("document", "idDocumentOperationType", option.key)}
                                required
                                selectedKey={this.state.document.idDocumentOperationType}
                            />
                            : null}

                        {this.props.type === 'Lot' ?
                            <ComboBoxDocumentLotType
                                idDocumentLotCategorie={this.state.document.idDocumentLotCategorie}
                                onChange={(event, option) => this._onMiseAJourChamp("document", "idDocumentLotType", option.key)}
                                required
                                selectedKey={this.state.document.idDocumentLotType}
                            />
                            : null}
                    </div>
                    <div className="ms-Grid-col ms-sm12">
                        <Toggle
                            label="Obligatoire"
                            onText="Oui"
                            offText="Non"
                            disabled
                            checked={this.state.document.obligatoire}
                            onChange={(e, isChecked) => this._onMiseAJourChamp("document", "obligatoire", isChecked)}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12">
                        <Toggle
                            label="Dossier client type"
                            onText="Oui"
                            offText="Non"
                            checked={this.state.document.appartientDossierClientParDefaut}
                            onChange={(e, isChecked) => this._onMiseAJourChamp("document", "appartientDossierClientParDefaut", isChecked)}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12">
                        <Toggle
                            label="Accessible Espace de vente"
                            onText="Oui"
                            offText="Non"
                            checked={this.state.document.accessibleEspaceDeVente}
                            onChange={(e, isChecked) => this._onMiseAJourChamp("document", "accessibleEspaceDeVente", isChecked)}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12">
                        <Toggle
                            label="Fusionnable"
                            onText="Oui"
                            offText="Non"
                            checked={this.state.document.fusionnable}
                            disabled={!this.state.estAdminNational}
                            onChange={(e, isChecked) => this._onMiseAJourChamp("document", "fusionnable", isChecked)}
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12">
                        <Toggle
                            label="Actif"
                            onText="Oui"
                            offText="Non"
                            checked={this.state.document.actif}
                            disabled={!this.state.estAdminNational}
                            onChange={(e, isChecked) => this._onMiseAJourChamp("document", "actif", isChecked)}
                        />
                    </div>
                </div>
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        let rowGUIDRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.rowGUID, [this.state.rowGUID]);

        if (rowGUIDRenseigneeEtDifferent) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement du document en cours'
            });

            var chargementDocument = DataDocument._chargementDocument(this.props.rowGUID, this.props.idLot, this.props.idOperation, this.props.idAgence, this.props.idRegion);

            chargementDocument
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;

                        let stateTemp = {};
                        stateTemp.rowGUID = this.props.rowGUID;
                        stateTemp.document = objetData[0][0];
                        stateTemp.estAdminNational = objetData[1];
                        stateTemp.titrePanel = 'Modifier le document';

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, stateTemp, this._onVerificationFormulaire);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du document en cours'
        });

        var enregistrementDocument = DataDocument._onEnregistrementDocument(this.props.type, this.state.document);

        enregistrementDocument
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    if (objetData === true) {
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                        this.props.onEnregistrementFiche();
                    }
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onRenderFooterContent = () => {
        let boutonActif = this.state.onActiveBoutonEnregistrer;

        return (<div>
            <PrimaryButton name="btnEnregistrerDocument" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!boutonActif}>Enregistrer</PrimaryButton>
            <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
        </div>);
    };

    _onMiseAJourChamp = (nomObjet, nomPropriete, valeur) => {

        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);
    }

    _onChangedDocumentOperationCategorie = (valeur) => {
        let documentTrav = { ...this.state.document };
        documentTrav.idDocumentOperationCategorie = valeur;
        documentTrav.idDocumentOperationType = 0;

        this.setState({
            document: documentTrav
        }, this._onVerificationFormulaire);
    }

    _onChangedDocumentLotCategorie = (valeur) => {
        let documentTrav = { ...this.state.document };
        documentTrav.idDocumentLotCategorie = valeur;
        documentTrav.idDocumentLotType = 0;

        this.setState({
            document: documentTrav
        }, this._onVerificationFormulaire);
    }

    _onMiseAJourChampNomDocument = (nomObjet, nomPropriete, nomFichier, extension) => {
        nomFichier = (nomFichier != "" ? nomFichier + '.' + extension : "");
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, nomFichier, this._onVerificationFormulaire);
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    _onVerificationFormulaire() {
        let documentTrav = { ...this.state.document };
        documentTrav.type = this.props.type;
        Immocom.fiche()._validationFormulaire(this, 'Document', documentTrav, (this.state.document.rowGUID !== null ? 'Modification' : 'Création'));
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
        //if ((this.props.rowGUID !== undefined && this.props.rowGUID !== null && this.props.rowGUID !== this.state.rowGUID) && !this.state.enCoursDeTraitement) {
        //    this._chargementDonnees();
        //}
    }

    render() {
        let content = this._creationContent();

        return (
            <Panel
                isOpen={this.props.onAffichePanelDocument}
                headerText={this.state.titrePanel}
                type={PanelType.medium}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className={this.props.classname}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            {content}
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }
}